module.exports = __webpack_public_path__ + "static/media/company-name-hide.a1068fcb.png";